module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-02@2x.a8427d82.jpg";